import type { ScoutAccessDto, ScoutAccessMember, SaveScoutAccessRequest } from '@signalvote/shared';

/** The admin's unsaved edits. `null` in the card means "no edits", so the view follows the server. */
export interface ScoutAccessDraft {
  enabled: boolean;
  userIds: string[];
}

export interface ScoutAccessView {
  enabled: boolean;
  listed: ScoutAccessMember[];
  addable: ScoutAccessMember[];
  dirty: boolean;
  request: SaveScoutAccessRequest;
}

const byName = (a: ScoutAccessMember, b: ScoutAccessMember) => a.name.localeCompare(b.name);

export function viewScoutAccess(access: ScoutAccessDto, draft: ScoutAccessDraft | null): ScoutAccessView {
  const saved = new Set(access.allowlist.map((m) => m.userId));
  const enabled = draft?.enabled ?? access.enabled;
  const ids = new Set(draft?.userIds ?? saved);

  const members = new Map<string, ScoutAccessMember>();
  for (const m of [...access.eligible, ...access.allowlist]) members.set(m.userId, m);

  const listed = [...ids].flatMap((id) => members.get(id) ?? []).sort(byName);
  const addable = access.eligible.filter((m) => !ids.has(m.userId)).sort(byName);
  const dirty =
    enabled !== access.enabled || ids.size !== saved.size || [...ids].some((id) => !saved.has(id));

  return {
    enabled,
    listed,
    addable,
    dirty,
    request: {
      enabled,
      userIds: listed.map((m) => m.userId),
      concurrencyVersion: access.concurrencyVersion,
    },
  };
}
